import { useCallback, useState } from 'react';
import { ParteProcesso } from '../interfaces';
import { List, ListItem, CustomCheckbox, CheckboxLabel, DeleteButton, Badge, IconContainer, ParteInfo, TooltipContainer, Tooltip } from './styles';
import { IconUser } from '../../../../../icons';
import { Trash2 } from 'lucide-react';
import { comum } from '../../../../../../styles/Themes/light';

interface PartesProcessoListProps {
    partes: ParteProcesso[];
    isEditing: boolean;
    isDisabled: boolean;
    onAlternarRepresentada: (parte: ParteProcesso) => void;
    onExcluir: (id: number, nome: string) => void;
}

export default function PartesProcessoList({
    partes,
    isEditing,
    isDisabled,
    onAlternarRepresentada,
    onExcluir
}: PartesProcessoListProps) {
    const [mostrarTooltip, setMostrarTooltip] = useState<number | null>(null);

    const handleExcluir = useCallback((parte: ParteProcesso) => {
        if (!isDisabled) {
            onExcluir(parte.id_parte_processo, parte.nome);
        }
    }, [isDisabled, onExcluir]);

    const handleAlternarRepresentada = useCallback((parte: ParteProcesso) => {
        if (!isDisabled) {
            onAlternarRepresentada(parte);
        }
    }, [isDisabled, onAlternarRepresentada]);

    if (partes.length === 0) {
        return <div className="nao-encontrado">Nenhuma parte adicionada</div>;
    }

    return (
        <List>
            {partes.map((parte) => (
                <ListItem key={parte.id_parte_processo}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }}>
                        <IconContainer>
                            <IconUser color={comum.colors.primaryRed400} />
                        </IconContainer>
                        <ParteInfo>
                            <span>
                                <span style={{ fontWeight: '600' }}>
                                    {parte.tipo.charAt(0).toUpperCase() + parte.tipo.slice(1)}:
                                </span>{' '}
                                {parte.nome}
                            </span>
                        </ParteInfo>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {!isEditing && parte.id_parte_representada !== null && (
                            <Badge variant="representada">Representada</Badge>
                        )}
                        {isEditing && (
                            <>
                                <TooltipContainer
                                    onMouseEnter={() => setMostrarTooltip(parte.id_parte_processo)}
                                    onMouseLeave={() => setMostrarTooltip(null)}
                                >
                                    <CheckboxLabel
                                        onClick={() => handleAlternarRepresentada(parte)}
                                        style={{
                                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                                            opacity: isDisabled ? 0.6 : 1
                                        }}
                                    >
                                        <CustomCheckbox checked={parte.id_parte_representada !== null} />
                                        <span>Rep.</span>
                                    </CheckboxLabel>
                                    {mostrarTooltip === parte.id_parte_processo && (
                                        <Tooltip>Representada</Tooltip>
                                    )}
                                </TooltipContainer>
                                <DeleteButton
                                    onClick={() => handleExcluir(parte)}
                                    disabled={isDisabled}
                                >
                                    <Trash2 size={14} />
                                </DeleteButton>
                            </>
                        )}
                    </div>
                </ListItem>
            ))}
        </List>
    );
}

